import React, { useState, useEffect, useCallback, useRef } from 'react'
import AuthService from '../../services/auth.service'
import NeoButton from '../../components/NeoButton/NeoButton'
import { useParams, useLocation, useHistory } from 'react-router-dom'
import Loading from 'custom/assets/loaders/Loading'
import { isMobileOnly, isTablet } from 'react-device-detect'

function VerifyLink() {
  const [stage, setStage] = useState(0)
  const [message, setMessage] = useState('')
  const history = useHistory()
  //const location = useLocation()
  let operation = window.location.hash.split('/')

  const [error, setError] = useState('Error Placeholder')
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    getVerification()
  }, [])

  const getVerification = useCallback(async () => {
    setLoading(true)
    // await getStyles()
    // if (operation[4] != undefined && operation[5] != undefined &&
    //     operation[6] != undefined && operation[7] != undefined) {
    try {
      const response = await AuthService.verifyRegistration({
        operation: operation[5],
        token: operation[6],
        userName: operation[7],
      })
      setError(response)
      setMessage(response)
      setStage(1)
      setLoading(false)
    } catch (error) {
      setMessage(error)
      setError(error)
      setStage(1)
      setLoading(false)
    }
    // }
  }, [setLoading])

  function renderSwitch() {
    switch (stage) {
      case 0:
        return renderLoading()
      case 1:
        return Verification()
      default:
        return renderLoading()
    }
  }

  function renderLoading() {
    return (
      <div className='mx-4 rounded d-flex justify-content-center align-items-center'>
        <Loading />
      </div>
    )
  }

  function Verification() {
    return (
      <div className='d-flex flex-column h-100 mx-2 row justify-content-center align-items-center'>
        <h3 className='my-4 mx-2'>{message}</h3>

        <div style={{ width: 150 }}>
          <NeoButton onClick={()=>history.push('/auth')} type='submit' mode='newDesign' text={'Ok'} />
        </div>

        {/* {(isMobileOnly || isTablet)? (
              ''
            ) : (<a href='' className='btn btn-block btn-neo mt-4 mx-2' style={{width:'200px'}}>OK</a>)} */}
      </div>
    )
  }

  return <div id='verifyLink'>{renderSwitch()}</div>
}

export default VerifyLink
